module.exports = __webpack_public_path__ + "images/smartphone-screen-2-v2_0a7b0265527abdf8d1c9714d454edc9a.png";